module.exports = ".row {\n  line-height: 1.8;\n  font-size: 15px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/+app-custom/components/publication-registration/base-summary-form-part/author-summary-part/author-summary-part.component.scss
// module id = ./src/app/+app-custom/components/publication-registration/base-summary-form-part/author-summary-part/author-summary-part.component.scss
// module chunks = main